import {PlaceHolder} from "../PlaceHolder";
import {ClosedGap} from "../Model/Constants";
import {ChartItemBase} from "./ChartItemBase";

export class ComClosedGap extends ChartItemBase {

    constructor() {
        super();

        this.state = {};
        this.target = null;
        this.mouth = null;

        this.setTarget = this.setTarget.bind(this);
        this.executeTreatment = this.executeTreatment.bind(this);
    };

    toString() {
        return ClosedGap;
    }

    canExecute(target) {

        try {

            return (target instanceof PlaceHolder)
        } catch (e) {
            return false;
        }
    }

    executeBase(mouth, target) {

        // set the chart entry
        let entry = this.createNewEntry(mouth, ClosedGap, true);
        entry.position = target.pos.perm;
        entry.jaw = target.jaw;

        mouth.props.addChartEntry(entry);
        // fire on change for save icon etc
        mouth.props.onChange({owner: 'baseChartingEntered', value: true});
    }

    executeTreatment(mouth, target) {

        // set the chart entry
        let entry = this.createNewEntry(mouth, ClosedGap, false);
        entry.position = target.pos.perm;
        entry.jaw = target.jaw;

        mouth.props.addTreatmentHandler(entry);
    }

    setTarget(target) {
        this.target = target;
    }

    getCommandContextMenuItems() {
        return [];
    }

    clear() {
    }
}
